/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'checkin': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(8 10)" _stroke="#00272E"><path pid="0" d="M15.767 11.4a1.2 1.2 0 001.185-1.398 8.52 8.52 0 00-16.77 0A1.2 1.2 0 001.367 11.4h14.4z"/><path pid="1" d="M8.566 3V.6"/><path pid="2" d="M11.566.6h-6"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/checkin.js